import styled, { css } from "styled-components";

export const MessagesStyled = styled.ul`
    margin-top: 20px;
`;

export const MessageStyled = styled.li`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding-right: 5px;
    align-items: ${({ isAdmin }) => isAdmin ? 'flex-end' : 'flex-start'};
    text-align: ${({ isAdmin }) => isAdmin ? 'right' : 'left'};
`;

export const TextStyled = styled.div`
    ${({ theme }) => theme.fonts.openSansLight};
    font-size: 14px;
    line-height: 20px;
    max-width: 48%;
    padding: 10px 15px;
    border-radius: 10px;
    margin-bottom: 10px;
    color: ${({ isAdmin, theme }) => isAdmin ? theme.colors.white : theme.colors.darkGrey};
    background-color: ${({ isAdmin, theme }) => isAdmin ? theme.colors.blue : theme.colors.lightGrey};
    ${({ isAdmin }) => isAdmin ? css`border-bottom-right-radius: 0` : css`border-bottom-left-radius: 0`}
`;